import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import {useTypedSelector} from "../reducers";
import { LoadPanel } from "devextreme-react/load-panel";
import { handleError } from "../error/ErrorHandler";

type Props = {
    brdId: number;
}

const StaticContent: FC<Props> = ({brdId}) => {
    const { site } = useTypedSelector(state => state.profile);
    const [post, setPost] = useState([]);
    const [ loading, setLoading ] = useState(false);

    const getBoardPostById = async() => {
        setLoading(true);
        try {
            const res = await axios.get(`/api/board/post/one/${brdId}`);
            console.log('정적페이지:', res.data)
            if (res.data) setPost(res.data.brdContent);
        } catch(err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (brdId !== 0) getBoardPostById();
    }, [brdId]);

    return (
        <div className={`static-content-wrapper ${site}`}>
            <div className={'static-content-body'}>
                { loading &&
                    <LoadPanel visible={true} />
                }
                <div className={'text-center'} dangerouslySetInnerHTML={{__html: String(post)}} />
            </div>
        </div>
    );
}

export default StaticContent;
